import { EventBannerSerialized, IEventBannerViewModel } from "typings";

export const eventBannerViewModelCreator = ({ data: { payload } }): IEventBannerViewModel[] =>
  payload.map(({ id, image, redirect_url }: EventBannerSerialized) => ({
    id,
    imageUrl: image,
    eventUrl: redirect_url
  }));
